module.exports = __webpack_public_path__ + "static/img/design-samsung.0ede576.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung.png
// module id = K9xA
// module chunks = 0